import type { Message } from 'ably';
import { useChannel } from 'ably/react';

/**
 * Abonnement à un canal Ably, à ne rendre que si ce canal existe : `useChannel` exige un
 * fournisseur Ably et plante sans, même avec `skip`. Les cartes d'interaction peuvent ainsi
 * s'afficher hors d'une salle live (salle de test Evergreen).
 */
export default function AblyChannelListener({
  channelName,
  onMessage,
}: {
  channelName: string;
  onMessage: (message: Message) => void;
}) {
  useChannel(channelName, onMessage);
  return null;
}
